module.exports = __webpack_public_path__ + "img/outsourcing.cd64e4ce.jpg";